<template>
	<div>
		<div class="animated fadeIn">
			<CommandHeaderV2 :command_service_id="service_id" :record_id="command_id" active="result">
				<div class="wrapper">
					<b-nav tabs class="response-component-steps">
						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/type`"
							>Types</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/options`"
							>Options</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/template`"
							>Templates</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/fallback`"
							>Fallback</router-link>
						</b-nav-item>

						<hr style="width: 165px;"/>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/extra-options`"
							>Extra options</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/user-data`"
							>User Data</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/response-actions`"
							>Response Actions</router-link>
						</b-nav-item>

						<b-nav-item>
							<router-link
								class="btn btn-dark btn-block"
								:to="`/services/${service_id}/commands/${command_id}/result/advertises`"
							>Advertises</router-link>
						</b-nav-item>
					</b-nav>
					<div class="container step-container">
						<router-view></router-view>
					</div>
				</div>
			</CommandHeaderV2>
		</div>
	</div>
</template>

<script>
import CommandHeaderV2 from '../components/CommandHeaderV2'

export default {
	components: {
		CommandHeaderV2,
	},
	data() {
		return {
			service_id: 0,
			command_id: 0,
		}
	},

	async created() {
		if (parseInt(this.$route.params.service_id)) {
			this.service_id = parseInt(this.$route.params.service_id)
			this.$store.commit('set_go_services_id', this.service_id)
		}
		if (parseInt(this.$route.params.command_id)) {
			this.command_id = parseInt(this.$route.params.command_id)
			this.$store.commit('set_go_commands_id', this.command_id)
		}
	},

	computed: {
		// optionsDisabled() {
		//     const hasNoOptionsTypes = responseTypes.filter(type => type.has_options === false);
		//     return commandResponse.type
		// }
	},
}
</script>

<style lang="scss" scoped>
$bp: 992px;
.wrapper {
	display: flex;
	justify-content: center;
	@media screen and(max-width: $bp) {
		flex-direction: column;
	}
	> div,
	ul {
		padding: 2rem 1rem;
	}
	.response-component-steps.nav-tabs {
		display: flex;
		flex-direction: column;
		@media screen and(min-width: $bp) {
			border-right: 2px solid #e4e5e6;
			margin-right: 2rem;
			min-width: 200px;
			border-bottom: 0;
		}
		@media screen and(max-width: $bp) {
			width: 100%;
			border-bottom: 2px solid #e4e5e6;
			margin-bottom: 2rem;
			flex-direction: row;
			flex-wrap: wrap;
		}

		a {
			text-decoration: none;
			border: 0;
		}
	}
}
</style>
